function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { cloneDeep, isEqual, merge } from 'lodash-es';
import { LeafBlot, EmbedBlot, Scope, ParentBlot } from 'parchment';
import Delta, { AttributeMap, Op } from 'quill-delta';
import Block, { BlockEmbed, bubbleFormats } from '../blots/block.js';
import Break from '../blots/break.js';
import CursorBlot from '../blots/cursor.js';
import TextBlot, { escapeText } from '../blots/text.js';
import { Range } from './selection.js';
var ASCII = /^[ -~]*$/;

var Editor =
/*#__PURE__*/
function () {
  function Editor(scroll) {
    _classCallCheck(this, Editor);

    this.scroll = scroll;
    this.delta = this.getDelta();
  }

  _createClass(Editor, [{
    key: "applyDelta",
    value: function applyDelta(delta) {
      var _this = this;

      this.scroll.update();
      var scrollLength = this.scroll.length();
      this.scroll.batchStart();
      var normalizedDelta = normalizeDelta(delta);
      var deleteDelta = new Delta();
      var normalizedOps = splitOpLines(normalizedDelta.ops.slice());
      normalizedOps.reduce(function (index, op) {
        var length = Op.length(op);
        var attributes = op.attributes || {};
        var isImplicitNewlinePrepended = false;
        var isImplicitNewlineAppended = false;

        if (op.insert != null) {
          deleteDelta.retain(length);

          if (typeof op.insert === 'string') {
            var text = op.insert;
            isImplicitNewlineAppended = !text.endsWith('\n') && (scrollLength <= index || !!_this.scroll.descendant(BlockEmbed, index)[0]);

            _this.scroll.insertAt(index, text);

            var _this$scroll$line = _this.scroll.line(index),
                _this$scroll$line2 = _slicedToArray(_this$scroll$line, 2),
                line = _this$scroll$line2[0],
                offset = _this$scroll$line2[1];

            var formats = merge({}, bubbleFormats(line));

            if (line instanceof Block) {
              var _line$descendant = line.descendant(LeafBlot, offset),
                  _line$descendant2 = _slicedToArray(_line$descendant, 1),
                  leaf = _line$descendant2[0];

              if (leaf) {
                formats = merge(formats, bubbleFormats(leaf));
              }
            }

            attributes = AttributeMap.diff(formats, attributes) || {};
          } else if (_typeof(op.insert) === 'object') {
            var key = Object.keys(op.insert)[0]; // There should only be one key

            if (key == null) return index;
            var isInlineEmbed = _this.scroll.query(key, Scope.INLINE) != null;

            if (isInlineEmbed) {
              if (scrollLength <= index || !!_this.scroll.descendant(BlockEmbed, index)[0]) {
                isImplicitNewlineAppended = true;
              }
            } else if (index > 0) {
              var _this$scroll$descenda = _this.scroll.descendant(LeafBlot, index - 1),
                  _this$scroll$descenda2 = _slicedToArray(_this$scroll$descenda, 2),
                  _leaf = _this$scroll$descenda2[0],
                  _offset = _this$scroll$descenda2[1];

              if (_leaf instanceof TextBlot) {
                var _text = _leaf.value();

                if (_text[_offset] !== '\n') {
                  isImplicitNewlinePrepended = true;
                }
              } else if (_leaf instanceof EmbedBlot && _leaf.statics.scope === Scope.INLINE_BLOT) {
                isImplicitNewlinePrepended = true;
              }
            }

            _this.scroll.insertAt(index, key, op.insert[key]);

            if (isInlineEmbed) {
              var _this$scroll$descenda3 = _this.scroll.descendant(LeafBlot, index),
                  _this$scroll$descenda4 = _slicedToArray(_this$scroll$descenda3, 1),
                  _leaf2 = _this$scroll$descenda4[0];

              if (_leaf2) {
                var _formats = merge({}, bubbleFormats(_leaf2));

                attributes = AttributeMap.diff(_formats, attributes) || {};
              }
            }
          }

          scrollLength += length;
        } else {
          deleteDelta.push(op);

          if (op.retain !== null && _typeof(op.retain) === 'object') {
            var _key = Object.keys(op.retain)[0];
            if (_key == null) return index;

            _this.scroll.updateEmbedAt(index, _key, op.retain[_key]);
          }
        }

        Object.keys(attributes).forEach(function (name) {
          _this.scroll.formatAt(index, length, name, attributes[name]);
        });
        var prependedLength = isImplicitNewlinePrepended ? 1 : 0;
        var addedLength = isImplicitNewlineAppended ? 1 : 0;
        scrollLength += prependedLength + addedLength;
        deleteDelta.retain(prependedLength);
        deleteDelta["delete"](addedLength);
        return index + length + prependedLength + addedLength;
      }, 0);
      deleteDelta.reduce(function (index, op) {
        if (typeof op["delete"] === 'number') {
          _this.scroll.deleteAt(index, op["delete"]);

          return index;
        }

        return index + Op.length(op);
      }, 0);
      this.scroll.batchEnd();
      this.scroll.optimize();
      return this.update(normalizedDelta);
    }
  }, {
    key: "deleteText",
    value: function deleteText(index, length) {
      this.scroll.deleteAt(index, length);
      return this.update(new Delta().retain(index)["delete"](length));
    }
  }, {
    key: "formatLine",
    value: function formatLine(index, length) {
      var _this2 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.scroll.update();
      Object.keys(formats).forEach(function (format) {
        _this2.scroll.lines(index, Math.max(length, 1)).forEach(function (line) {
          line.format(format, formats[format]);
        });
      });
      this.scroll.optimize();
      var delta = new Delta().retain(index).retain(length, cloneDeep(formats));
      return this.update(delta);
    }
  }, {
    key: "formatText",
    value: function formatText(index, length) {
      var _this3 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      Object.keys(formats).forEach(function (format) {
        _this3.scroll.formatAt(index, length, format, formats[format]);
      });
      var delta = new Delta().retain(index).retain(length, cloneDeep(formats));
      return this.update(delta);
    }
  }, {
    key: "getContents",
    value: function getContents(index, length) {
      return this.delta.slice(index, index + length);
    }
  }, {
    key: "getDelta",
    value: function getDelta() {
      return this.scroll.lines().reduce(function (delta, line) {
        return delta.concat(line.delta());
      }, new Delta());
    }
  }, {
    key: "getFormat",
    value: function getFormat(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var lines = [];
      var leaves = [];

      if (length === 0) {
        this.scroll.path(index).forEach(function (path) {
          var _path = _slicedToArray(path, 1),
              blot = _path[0];

          if (blot instanceof Block) {
            lines.push(blot);
          } else if (blot instanceof LeafBlot) {
            leaves.push(blot);
          }
        });
      } else {
        lines = this.scroll.lines(index, length);
        leaves = this.scroll.descendants(LeafBlot, index, length);
      }

      var _map = [lines, leaves].map(function (blots) {
        var blot = blots.shift();
        if (blot == null) return {};
        var formats = bubbleFormats(blot);

        while (Object.keys(formats).length > 0) {
          var _blot = blots.shift();

          if (_blot == null) return formats;
          formats = combineFormats(bubbleFormats(_blot), formats);
        }

        return formats;
      }),
          _map2 = _slicedToArray(_map, 2),
          lineFormats = _map2[0],
          leafFormats = _map2[1];

      return _objectSpread({}, lineFormats, leafFormats);
    }
  }, {
    key: "getHTML",
    value: function getHTML(index, length) {
      var _this$scroll$line3 = this.scroll.line(index),
          _this$scroll$line4 = _slicedToArray(_this$scroll$line3, 2),
          line = _this$scroll$line4[0],
          lineOffset = _this$scroll$line4[1];

      if (line) {
        var lineLength = line.length();
        var isWithinLine = line.length() >= lineOffset + length;

        if (isWithinLine && !(lineOffset === 0 && length === lineLength)) {
          return convertHTML(line, lineOffset, length, true);
        }

        return convertHTML(this.scroll, index, length, true);
      }

      return '';
    }
  }, {
    key: "getText",
    value: function getText(index, length) {
      return this.getContents(index, length).filter(function (op) {
        return typeof op.insert === 'string';
      }).map(function (op) {
        return op.insert;
      }).join('');
    }
  }, {
    key: "insertContents",
    value: function insertContents(index, contents) {
      var normalizedDelta = normalizeDelta(contents);
      var change = new Delta().retain(index).concat(normalizedDelta);
      this.scroll.insertContents(index, normalizedDelta);
      return this.update(change);
    }
  }, {
    key: "insertEmbed",
    value: function insertEmbed(index, embed, value) {
      this.scroll.insertAt(index, embed, value);
      return this.update(new Delta().retain(index).insert(_defineProperty({}, embed, value)));
    }
  }, {
    key: "insertText",
    value: function insertText(index, text) {
      var _this4 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      this.scroll.insertAt(index, text);
      Object.keys(formats).forEach(function (format) {
        _this4.scroll.formatAt(index, text.length, format, formats[format]);
      });
      return this.update(new Delta().retain(index).insert(text, cloneDeep(formats)));
    }
  }, {
    key: "isBlank",
    value: function isBlank() {
      if (this.scroll.children.length === 0) return true;
      if (this.scroll.children.length > 1) return false;
      var blot = this.scroll.children.head;
      if ((blot === null || blot === void 0 ? void 0 : blot.statics.blotName) !== Block.blotName) return false;
      var block = blot;
      if (block.children.length > 1) return false;
      return block.children.head instanceof Break;
    }
  }, {
    key: "removeFormat",
    value: function removeFormat(index, length) {
      var text = this.getText(index, length);

      var _this$scroll$line5 = this.scroll.line(index + length),
          _this$scroll$line6 = _slicedToArray(_this$scroll$line5, 2),
          line = _this$scroll$line6[0],
          offset = _this$scroll$line6[1];

      var suffixLength = 0;
      var suffix = new Delta();

      if (line != null) {
        suffixLength = line.length() - offset;
        suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
      }

      var contents = this.getContents(index, length + suffixLength);
      var diff = contents.diff(new Delta().insert(text).concat(suffix));
      var delta = new Delta().retain(index).concat(diff);
      return this.applyDelta(delta);
    }
  }, {
    key: "update",
    value: function update(change) {
      var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var selectionInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      var oldDelta = this.delta;

      if (mutations.length === 1 && mutations[0].type === 'characterData' && // @ts-expect-error Fix me later
      mutations[0].target.data.match(ASCII) && this.scroll.find(mutations[0].target)) {
        // Optimization for character changes
        var textBlot = this.scroll.find(mutations[0].target);

        var _formats2 = bubbleFormats(textBlot);

        var index = textBlot.offset(this.scroll); // @ts-expect-error Fix me later

        var oldValue = mutations[0].oldValue.replace(CursorBlot.CONTENTS, '');
        var oldText = new Delta().insert(oldValue); // @ts-expect-error

        var newText = new Delta().insert(textBlot.value());
        var relativeSelectionInfo = selectionInfo && {
          oldRange: shiftRange(selectionInfo.oldRange, -index),
          newRange: shiftRange(selectionInfo.newRange, -index)
        };
        var diffDelta = new Delta().retain(index).concat(oldText.diff(newText, relativeSelectionInfo));
        change = diffDelta.reduce(function (delta, op) {
          if (op.insert) {
            return delta.insert(op.insert, _formats2);
          }

          return delta.push(op);
        }, new Delta());
        this.delta = oldDelta.compose(change);
      } else {
        this.delta = this.getDelta();

        if (!change || !isEqual(oldDelta.compose(change), this.delta)) {
          change = oldDelta.diff(this.delta, selectionInfo);
        }
      }

      return change;
    }
  }]);

  return Editor;
}();

function convertListHTML(items, lastIndent, types) {
  if (items.length === 0) {
    var _getListType = getListType(types.pop()),
        _getListType2 = _slicedToArray(_getListType, 1),
        _endTag = _getListType2[0];

    if (lastIndent <= 0) {
      return "</li></".concat(_endTag, ">");
    }

    return "</li></".concat(_endTag, ">").concat(convertListHTML([], lastIndent - 1, types));
  }

  var _items = _toArray(items),
      _items$ = _items[0],
      child = _items$.child,
      offset = _items$.offset,
      length = _items$.length,
      indent = _items$.indent,
      type = _items$.type,
      rest = _items.slice(1);

  var _getListType3 = getListType(type),
      _getListType4 = _slicedToArray(_getListType3, 2),
      tag = _getListType4[0],
      attribute = _getListType4[1];

  if (indent > lastIndent) {
    types.push(type);

    if (indent === lastIndent + 1) {
      return "<".concat(tag, "><li").concat(attribute, ">").concat(convertHTML(child, offset, length)).concat(convertListHTML(rest, indent, types));
    }

    return "<".concat(tag, "><li>").concat(convertListHTML(items, lastIndent + 1, types));
  }

  var previousType = types[types.length - 1];

  if (indent === lastIndent && type === previousType) {
    return "</li><li".concat(attribute, ">").concat(convertHTML(child, offset, length)).concat(convertListHTML(rest, indent, types));
  }

  var _getListType5 = getListType(types.pop()),
      _getListType6 = _slicedToArray(_getListType5, 1),
      endTag = _getListType6[0];

  return "</li></".concat(endTag, ">").concat(convertListHTML(items, lastIndent - 1, types));
}

function convertHTML(blot, index, length) {
  var isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if ('html' in blot && typeof blot.html === 'function') {
    return blot.html(index, length);
  }

  if (blot instanceof TextBlot) {
    var escapedText = escapeText(blot.value().slice(index, index + length));
    return escapedText.replaceAll(' ', '&nbsp;');
  }

  if (blot instanceof ParentBlot) {
    // TODO fix API
    if (blot.statics.blotName === 'list-container') {
      var items = [];
      blot.children.forEachAt(index, length, function (child, offset, childLength) {
        var formats = 'formats' in child && typeof child.formats === 'function' ? child.formats() : {};
        items.push({
          child: child,
          offset: offset,
          length: childLength,
          indent: formats.indent || 0,
          type: formats.list
        });
      });
      return convertListHTML(items, -1, []);
    }

    var parts = [];
    blot.children.forEachAt(index, length, function (child, offset, childLength) {
      parts.push(convertHTML(child, offset, childLength));
    });

    if (isRoot || blot.statics.blotName === 'list') {
      return parts.join('');
    }

    var _blot$domNode = blot.domNode,
        outerHTML = _blot$domNode.outerHTML,
        innerHTML = _blot$domNode.innerHTML;

    var _outerHTML$split = outerHTML.split(">".concat(innerHTML, "<")),
        _outerHTML$split2 = _slicedToArray(_outerHTML$split, 2),
        start = _outerHTML$split2[0],
        end = _outerHTML$split2[1]; // TODO cleanup


    if (start === '<table') {
      return "<table style=\"border: 1px solid #000;\">".concat(parts.join(''), "<").concat(end);
    }

    return "".concat(start, ">").concat(parts.join(''), "<").concat(end);
  }

  return blot.domNode instanceof Element ? blot.domNode.outerHTML : '';
}

function combineFormats(formats, combined) {
  return Object.keys(combined).reduce(function (merged, name) {
    if (formats[name] == null) return merged;
    var combinedValue = combined[name];

    if (combinedValue === formats[name]) {
      merged[name] = combinedValue;
    } else if (Array.isArray(combinedValue)) {
      if (combinedValue.indexOf(formats[name]) < 0) {
        merged[name] = combinedValue.concat([formats[name]]);
      } else {
        // If style already exists, don't add to an array, but don't lose other styles
        merged[name] = combinedValue;
      }
    } else {
      merged[name] = [combinedValue, formats[name]];
    }

    return merged;
  }, {});
}

function getListType(type) {
  var tag = type === 'ordered' ? 'ol' : 'ul';

  switch (type) {
    case 'checked':
      return [tag, ' data-list="checked"'];

    case 'unchecked':
      return [tag, ' data-list="unchecked"'];

    default:
      return [tag, ''];
  }
}

function normalizeDelta(delta) {
  return delta.reduce(function (normalizedDelta, op) {
    if (typeof op.insert === 'string') {
      var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      return normalizedDelta.insert(text, op.attributes);
    }

    return normalizedDelta.push(op);
  }, new Delta());
}

function shiftRange(_ref, amount) {
  var index = _ref.index,
      length = _ref.length;
  return new Range(index + amount, length);
}

function splitOpLines(ops) {
  var split = [];
  ops.forEach(function (op) {
    if (typeof op.insert === 'string') {
      var lines = op.insert.split('\n');
      lines.forEach(function (line, index) {
        if (index) split.push({
          insert: '\n',
          attributes: op.attributes
        });
        if (line) split.push({
          insert: line,
          attributes: op.attributes
        });
      });
    } else {
      split.push(op);
    }
  });
  return split;
}

export default Editor;